<template>
  <FAQPage
    v-bind="faqPageProps"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { GET_REVIEWS } from '@/utils/store/actionTypes'
import { getImagePaths } from '@/utils/general'
import FAQPage from '@/components/FAQPage'
import customerServiceMixin from '@/mixins/customerService'

export default {
  name: 'MenCustomerService',
  layout: 'customer-service',
  components: {
    FAQPage
  },
  mixins: [customerServiceMixin],
  async fetch () {
    await this.loadReviews()
  },
  data () {
    return {
      reviewData: null
    }
  },
  computed: {
    faqPageProps () {
      return {
        blocks: this.blocks,
        locale: this.locale,
        reviewData: this.reviewData
      }
    },
    blocks () {
      return [
        {
          title: this.$t('FAQ.DynamicFaq.Payment'),
          image: getImagePaths({ path: '/images/frontend/faq/payment/image', s3: true }),
          questions: [
            this.getQuestionByPath('how-do-i-change-my-payment-details'),
            this.getQuestionByPath('what-does-an-on-that-ass-membership-cost'),
            this.getQuestionByPath('how-do-i-stop-a-debit')
          ]
        },
        {
          title: this.$t('FAQ.DynamicFaq.PauseOrCancel'),
          image: getImagePaths({ path: '/images/frontend/faq/status/image', s3: true }),
          questions: [
            this.getQuestionByPath('how-can-i-cancel'),
            this.getQuestionByPath('do-you-have-a-notice-period'),
            this.getQuestionByPath('i-would-like-confirmation-of-my-cancellation')
          ]
        },
        {
          title: this.$t('FAQ.DynamicFaq.Shipment'),
          image: getImagePaths({ path: '/images/frontend/faq/shipment/image', s3: true }),
          questions: [
            this.getQuestionByPath('when-will-i-receive-my-monthly-deliveries'),
            this.getQuestionByPath('i-have-not-received-my-boxer-shorts'),
            this.getQuestionByPath('how-do-i-change-my-address-details')
          ]
        }
      ]
    },
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  methods: {
    async loadReviews () {
      try {
        const { data: { reviewSite } } = await this.getReviews()

        const reviewData = {
          name: reviewSite.altText,
          rating: reviewSite.rating,
          maxRating: reviewSite.maxRating,
          amountReviews: reviewSite.amountReviews,
          url: reviewSite.url,
          src: process.env.BASE_S3_PATH + '/' + reviewSite.imagePath
        }

        this.reviewData = reviewData
      } catch (e) {
        this.$ota.general.logError(e)
      }
    },
    ...mapActions('app', {
      getReviews: GET_REVIEWS
    })
  }
}
</script>
